import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import SelectDropDown from '../component/SelectDropDown';
import HelpDeskServices from '../services/HelpDesk';
import ThemeTextarea from '../component/ThemeTextarea';
import PrimaryGradientButton from '../component/PrimaryGradientButton';
import Loader from '../component/Loader';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AlertMsg from '../component/AlertMsg';

const HelpDeskReply = () => {
    const navigate = useNavigate()
    const { ticketId,ticketNo } = useParams();
    const [loading, setLoading] = useState(true);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [statusOption, setStatusOption] = useState([]);
    const [isStatus, setIsStatus] = useState({ id: "", title: "" });
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [raiseTicketInput, setRaiseTicketInput] = useState(
        {
            issueSummary: '',
            issueDetails: ''
        }
    )
    const location = useLocation();
    // const selectedHelpDeskData = location.state.selectedHelpDeskData;
    const [isSelectedHelpDeskData, setIsSelectedHelpDeskData] = useState()
    const [statusErrorValidator, setStatusErrorValidator] = useState()
    const [issueSummaryErrorValidator, setIssueSummaryErrorValidator] = useState()
    const [isIssueDetailsErrorValidator, setIsIssueDetailsErrorValidator] = useState()
 
    //Object
    useEffect(() => {
        const statusFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const statusFetchDataResponse = await HelpDeskServices.allStatus(2, token)
                if (statusFetchDataResponse.apiStatus.message == "success") {
                    setStatusOption(statusFetchDataResponse.response?.map((item, index) => {
                        return {
                            id: item.id,
                            title: item.internal_status_name
                        }
                    }))
                    setLoading(false)
                }
            }
            catch (error) {
                console.error("StatusFetchData")

            }
        }
        statusFetchData()
    }, [])
    
    const handleChangeInput = (e) => {
        setRaiseTicketInput({ ...raiseTicketInput, [e.target.name]: e.target.value })
        switch(e.target.name){
            case 'issueSummary':
            setIssueSummaryErrorValidator('');
            break;
            case 'issueDetails':
            setIsIssueDetailsErrorValidator('');
            break;
        }

    }
    const handleStatusSelect = (selectedValue) => {
        setIsStatus(selectedValue)
        setStatusErrorValidator('')
    }
    //Reply API
    const handleReply = async () => {
        let isValid = true;
        const validations = [
            {value: raiseTicketInput.issueSummary, setter: setStatusErrorValidator, message: 'Status is required.' },
            {value: raiseTicketInput.issueDetails, setter: setIssueSummaryErrorValidator, message: 'Issue Summary is required.' },
            {value: isStatus.id, setter: setIsIssueDetailsErrorValidator, message: 'Issue Details is required' }
            
        ]
        validations.forEach(({ value, setter, message }) => {
            if (!value) {
              setter(message);
              isValid = false;
            }
            else {
                setter(''); // Clear the error message
            }
          });
        if (isValid) {
            try{
                const token = localStorage.getItem('access_token')
                const payload = {
                    "summary": raiseTicketInput.issueSummary,
                    "description": raiseTicketInput.issueDetails,
                    "status_id": parseInt(isStatus.id), // Get from status list
                    "ticket_id": parseInt(ticketId) // mandatory
                }
                setIsButtonLoading(true)
                const handleReplySubmit = await HelpDeskServices.replyTicket(payload, token)
                setIsButtonLoading(false)
                if (handleReplySubmit.apiStatus.message == 'success') {
                    setShowAlert(true)
                    setIsLoginSuccess({ isLogin: true, heading: 'Success', text: `You have succesfully replied to ${handleReplySubmit.ticketNo}` })
                    setTimeout(() => {
                        navigate('/helpdesk')
                    }, 2000)
                }
                else {
                    setIsButtonLoading(false)
                    setShowAlert(true)
                    setIsLoginSuccess({ isLogin: false, heading: 'Error', text: `Sorry,something error occured` })
    
                }
            }
           catch(error)
           {
            console.error("Help Desk Reply Submit" )
           }
        }

    }
    return (
        <>
            {loading && <Loader />}
            <BreadCrumbSecttion
                pageTitle="Raise A  New Ticket"
                currentPageName="Raise A New Ticket"
            />
            <section className='padTop50'>
                <Container>
                    <Row className='justify-content-center align-item-center h-100'>
                        <Col xs={12}>
                            <div className='userInfoBox'>
                                <div className='dashboard-title'>
                                    <h4>Reply to ticket id: {ticketNo}</h4>
                                </div>
                                <div className="dashboard-details">
                                    <Row>
                                        <Col xs={12} lg={3} className='raise-textarea'>
                                            <SelectDropDown
                                                labelName="Status"
                                                requiredStar="*"
                                                options={statusOption}
                                                selectedValue={isStatus}
                                                setSelectedValue={setIsStatus}
                                                onChange={handleStatusSelect} />
                                                {statusErrorValidator && (
                                                  <div className="error-message">{statusErrorValidator}</div>
                                                )}

                                        </Col>
                                        <Col xs={12} lg={3} className='raise-textarea'>
                                            <ThemeTextarea labelName="Issue Summary"
                                                requiredStar="*"
                                                name="issueSummary"
                                                value={raiseTicketInput.issueSummary}
                                                onChange={handleChangeInput} />
                                                {issueSummaryErrorValidator && (
                                                  <div className="error-message">{issueSummaryErrorValidator}</div>
                                                )}

                                        </Col>
                                        <Col xs={12} lg={3} className='raise-textarea'>
                                            <ThemeTextarea labelName="Issue Details"
                                                requiredStar="*"
                                                name="issueDetails"
                                                value={raiseTicketInput.issueDetails}
                                                onChange={handleChangeInput} />
                                                {isIssueDetailsErrorValidator && (
                                                  <div className="error-message">{isIssueDetailsErrorValidator}</div>
                                                )}

                                        </Col>
                                        <Col xs={12} lg={3} className='mt-4'>
                                            <PrimaryGradientButton 
                                            buttonText={isButtonLoading ? "Processing..." : "Submit"}
                                             onClick={handleReply}
                                             disabled={isButtonLoading} />
                                        </Col>
                                        <Col xs={12} lg={6} className='mt-4'>

                                            {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                heading={isLoginSuccess.heading}
                                                text={isLoginSuccess.text}
                                            />
                                            }

                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    )
}

export default HelpDeskReply